import { afterNextRender, Component, DestroyRef, ElementRef, inject } from '@angular/core';

/** Distância do fim (px) até a qual a lista ainda "gruda" no fim quando chega conteúdo. */
const STICK_THRESHOLD_PX = 96;

/**
 * Lista rolável do chat. Gruda no fim enquanto o usuário está perto dele: fala nova, o
 * typewriter crescendo ou um checklist mudando de linha rolam a lista junto. Se o usuário
 * subiu para reler algo, a lista o deixa lá (não arranca a leitura dele).
 *
 * O conteúdo é projetado; cada fala costuma ser um `ra-chat-bubble`.
 */
@Component({
    selector: 'ra-chat-message-list',
    template: `<ng-content />`,
    host: {
        class: 'ra-chat-message-list',
        role: 'log',
        'aria-live': 'polite',
        '(scroll)': 'onScroll()',
    },
    styles: `
        :host {
            display: block;
            min-height: 0;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 1.75rem 1.5rem;
            box-sizing: border-box;
            scrollbar-width: thin;
            scrollbar-color: var(--borderPrimary) transparent;
        }
    `,
})
export class RaChatMessageListComponent {
    private _host = inject<ElementRef<HTMLElement>>(ElementRef);
    private _stick = true;
    private _observer?: MutationObserver;

    constructor() {
        afterNextRender(() => {
            const element = this._host.nativeElement;
            this.scrollToBottom();

            this._observer = new MutationObserver(() => {
                if (this._stick) this.scrollToBottom();
            });
            this._observer.observe(element, { childList: true, subtree: true, characterData: true });
        });

        inject(DestroyRef).onDestroy(() => this._observer?.disconnect());
    }

    public onScroll(): void {
        const element = this._host.nativeElement;
        const distance = element.scrollHeight - element.scrollTop - element.clientHeight;
        this._stick = distance <= STICK_THRESHOLD_PX;
    }

    /** Leva ao fim e volta a grudar (ex.: o próprio usuário acabou de enviar). */
    public scrollToBottom(): void {
        const element = this._host.nativeElement;
        element.scrollTop = element.scrollHeight;
        this._stick = true;
    }
}
